import { RouterProvider } from "react-router-dom";
import { createRoot } from "react-dom/client";
import Provider from "@/app/Provider";
import { Toaster } from "@/components/ui/sonner";
import "@/lib/fonts";
import { router } from "@/router";
import "@/app/globals.css";
import "@/app/common.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element #root not found");
}

createRoot(rootElement).render(
  <Provider>
    <RouterProvider router={router} />
    <Toaster visibleToasts={1} duration={2000} />
  </Provider>,
);
